import { Component, ViewChild, NgZone, Input } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
  Slides,
  LoadingController,
  Platform,
  ToastController,
  AlertController,
} from 'ionic-angular';
import * as _ from 'lodash';
import * as debug from 'debug';
import * as jquery from 'jquery';
import { Capacitor, Plugins } from '@capacitor/core';
import { CrudApiProvider } from '../../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../../providers/tools/tools';
import { ConfigProvider } from '../../../providers/config/config';
import { FeedPreset, PostsProvider } from '../../../providers/posts/posts';
import { UserProvider } from '../../../providers/user/user';
import { GeolocationProvider } from '../../../providers/geolocation/geolocation';
import { FeedComponent } from '../../../components/feed/feed';
import { NewsBrowserProvider } from '../../../providers/news-browser/news-browser';
import { HintsProvider } from '../../../providers/hints/hints';
import { UserVerificationProvider } from '../../../providers/user-verification/user-verification';
import { AuthProvider } from '../../../providers/auth/auth';
import { PinnedPostsProvider } from '../../../providers/posts/pinned-posts';
import { OnboardingProvider } from '../../../providers/onboarding/onboarding';
import moment from 'moment';
const { IOSAppTracking } = Plugins;

declare let CmKit: any;

@IonicPage({
  segment: 'home-page',
})
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {
  log = debug('app:HomePage');

  @Input()
  newChatMessage = true;

  // Sub Nav Variables
  @ViewChild(Slides) slides: Slides;
  @ViewChild('feedAll') feedAll: FeedComponent;
  @ViewChild('feedLatest') feedLatest: FeedComponent;
  @ViewChild('feedNearby') feedNearby: FeedComponent;
  @ViewChild('feedFriends') feedFriends: FeedComponent;
  @ViewChild('feedLiveChats') feedLiveChats: FeedComponent;
  @ViewChild('feedNews') feedNews: FeedComponent;
  @ViewChild('feedForYou') feedForYou: FeedComponent;
  @ViewChild('contentAll') contentAll;
  @ViewChild('contentTop') contentTop;
  @ViewChild('contentLatest') contentLatest;
  @ViewChild('contentFriends') contentFriends;
  @ViewChild('contentNearby') contentNearby;
  @ViewChild('contentNews') contentNews;
  @ViewChild('introductionPost') introductionPost;
  @ViewChild('tagSlideover') tagSlideover;

  liveChatConfigs = this.configs.get('feature--live-chat');
  homeFeedName = this.configs.get('home-feed-name') || 'Feed';
  userId;
  readyForApp = false;
  refreshing = '';
  previewMode = false;
  feedPreset = FeedPreset;
  hasTriedHints = false;
  tags: any = [];
  selectedTags: any = [];
  openTagsModal = true;
  movePostFabUp = true;
  refresherEnabled = true;
  isScrolling = false;
  scrollHiding = false;
  lastScrollPosition = 0;
  subs = [];
  pinnedPosts = [];
  showPinnedPosts = true;
  showIntroPostEntryPoint;
  showPillsMenu = false;

  // slides/tabs
  slideTabs = _.filter(
    [
      { id: 'feed', label: 'For You' },
      { id: 'latest', label: 'Latest' },
      { id: 'friends', label: 'Friends' },
      { id: 'nearby', label: 'Nearby' },
      { id: 'news', label: 'News' },
    ],
    t => _.size(t)
  );
  activatedSlides: any = { 0: true };
  tabsActiveTab = 0;
  pageTitle = _.get(this.slideTabs[this.tabsActiveTab], 'label') || 'CDLLife';;
  showFilters = JSON.parse(localStorage.getItem('cdlc--show-feed-filters')) || false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public crud: CrudApiProvider,
    public platform: Platform,
    public zone: NgZone,
    public tools: ToolsProvider,
    public config: ConfigProvider,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public user: UserProvider,
    public postProvider: PostsProvider,
    public geolocation: GeolocationProvider,
    public newsBrowser: NewsBrowserProvider,
    public hints: HintsProvider,
    public authService: AuthProvider,
    public userVerification: UserVerificationProvider,
    public pinnedPostsService: PinnedPostsProvider,
    public crudApi: CrudApiProvider,
    public onboarding: OnboardingProvider,
    public configs: ConfigProvider,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController
  ) {
    this.subs.push(
      this.tools.on('resize', () => {
        try {
          this.slides.update();
        } catch (e) {}
      })
    );

    this.subs.push(
      this.tools.on('toggleTagsModal', () => {
        this.openTagsModal = true;
        this.openTagsModal
          ? this.tagSlideover.show()
          : this.tagSlideover.hide();
      })
    );

    this.subs.push(
      this.tools.on('changeActiveTab', tab => {
        this.changeActiveTabIndex(tab);
      })
    );

    this.subs.push(
      this.configs.on('hashtagsUpdated', hashtags => {
        const hs = _.compact(_.map(hashtags, 'selected'));
        this.log('hashtagsUpdates', hs);
        this.showPinnedPosts = !!!_.size(hs);
      })
    );

    this.subs.push(
      this.tools.on('toggleTag', tag => {
        if (tag) {
          this.toggleTag(tag);
        }
      })
    );

    this.subs.push(
      this.tools.on('resetSelected', () => {
        this.resetSelected();
      })
    );

    this.subs.push(
      this.tools.on('closeTagSlideOver', () => {
        this.tagSlideover.hide();
      })
    );

    this.subs.push(
      this.tools.on('forceMenusShow', e => {
        this.isScrolling = false;
        this.movePostFabUp = true;
      })
    );
  }

  ngOnInit() {
    this.previewMode = this.user.get('states.isUnauthedUser');
    this.authService.on('authenticated', () => {
      this.previewMode = this.user.get('states.isUnauthedUser');
    });

    if (!_.size(this.pinnedPostsService.pinnedPosts)) {
      this.pinnedPostsService.spinUp();
    }

    this.userId = this.user.get('_id');

    if (!this.user.hasFriends) {
      this.user.myFriends();
    }

    // setTimeout(() => {
    //   this.slides.lockSwipes(true);
    // });

    if (window['READY_FOR_APP']) {
      this.ready();
    } else {
      this.tools.on('readyForApp', () => {
        this.ready();
      });
    }

    setTimeout(() => {
      this.checkAppTrackingStatus();
    });

    this.tools.on(`post-pinned`, postId => {
      this.pinnedPostsService.spinUp();
    });

    this.tools.on(`post-unpinned`, postId => {
      this.pinnedPostsService.spinUp();
    });

    this.scrollHiding = this.configs.get('home-scroll-menus-hiding');
    this.showPillsMenu = this.configs.get('home-pills-menu');
  }

  ngAfterContentInit() {
    this.showIntroPostComponent();
    setTimeout(() => {
    
      this.showLastSeenTab();
    }, 1000);
  }

  showLastSeenTab() {
    if (this.configs.get('home-last-feed-save')) {
      const lastSeen = localStorage.getItem('cdlc--last-feed-id');
      if (lastSeen) {
        console.warn('changeActive here', lastSeen);
        const feedSlide = _.find(this.slides._slides, (s) => {
          console.warn('changeActive',s.id);
          return s.id === 's-' + lastSeen
        });

        if (feedSlide) {
          console.warn('changeActive',feedSlide);
          this.changeActiveTabIndex({id: _.replace(feedSlide.id, 's-', '')});
        }
      }
    }
  }

  handleShowFilters() {
    this.showFilters = !this.showFilters; 
    localStorage.setItem('cdlc--show-feed-filters', JSON.stringify(this.showFilters));
  }

  async betaTestingJoining() {
    if (localStorage.getItem('cdlc--live-chat') === 'joined') {
      return Promise.resolve('joined');
    }

    return new Promise((res, rej) => {
      this.alertCtrl
        .create({
          title: this.liveChatConfigs?.name || 'LiveChat',
          message:
            this.liveChatConfigs?.joinMessage ||
            `Would you like to join the ${
              this.liveChatConfigs?.name || 'LiveChat'
            } beta testing?`,
          cssClass: 'alertDeleteAccount',
          buttons: [
            {
              text: 'Join',
              cssClass: 'alert-button-cancel',
              handler: data => {
                console.warn('Join clicked');
                localStorage.setItem('cdlc--live-chat', 'joined');
                res('joined');
              },
            },
            {
              text: 'Cancel',
              cssClass: 'alert-button-cancel',
              handler: data => {
                console.warn('Cancel clicked');
                return rej('cancelled');
              },
            },
          ],
        })
        .present();
    });
  }

  emitHashTag(event) {
    let tag = { name: event };
    this.toggleTag(tag);
  }

  private ready() {
    this.zone.run(() => {
      this.readyForApp = true;
      if (!this.user.hasFriends) {
        this.user.myFriends();
      }
    });
  }

  private async checkAppTrackingStatus() {
    if (Capacitor.getPlatform() === 'ios' && window['cordova']) {
      const status = _.get(await IOSAppTracking.getTrackingStatus(), 'status');

      if (status === 'unrequested') {
        setTimeout(() => {
          CmKit.ActionSheet({
            props: {
              templates: {
                title: `
                <div style="text-align:center" class="cm-Margin--top cm-Margin--bottom">
                  <div class="cm-Avatar" cm-background="Neutral / White" style="font-size: 100px;">
                    <img src="assets/imgs/CDLLife.png"/>
                  </div>
                  <div cm-font="Title / 20 Medium"
                        class="cm-Margin--bottom cm-Margin--top"
                        cm-color="Neutral / Mine Shaft">
                    More choices for relevant ads on iOS 14.5+
                  </div>
                  <div cm-font="Body 16 / Regular"
                        class="cm-Margin--bottom"
                        cm-color="Neutral / Mine Shaft">
                    Keep ads relevant to you by allowing CDLLife to track
                    data from other companies on this device.
                    <br/>
                    <br/>
                    You can decide if you'll allow tracking in the iOS
                    prompt and you can always change this later in your device settings.
                  </div>
                </div>
              `,
                button: () => {
                  return `
                    <div style="text-align:center">
                      <button class="cm-Button cm-Button--2" cm-background="Primary / CDLLife Blue">Continue</button>
                    </div>
                  `;
                },
                cancel: '',
              },
              buttons: [
                {
                  text: 'Continue',
                  handler: () => {},
                },
              ],
            },
          }).promise.then(async res => {
            try {
              const newStatus = await IOSAppTracking.requestPermission();
              this.log('iOS app tracking transparency permission', newStatus);
            } catch (e) {
              this.log('error in iOS app tracking transparency prompt');
            }

            this.tryHints();
          });
        });
      }
    }
  }

  async tryHints() {
    if (this.previewMode) {
      return;
    }

    if (this.platform.is('ios') && window['cordova']) {
      if (
        _.get(await IOSAppTracking.getTrackingStatus(), 'status') ===
        'unrequested'
      )
        return;
    }
    if (this.hasTriedHints) return;
    this.hasTriedHints = true;

    this.hints
      .hintWorkflow('FEED_TABS')
      .onVisit(0, [
        {
          selector: '.account-Menu-toggle',
          text: 'Here you’ll find your account information',
          forceCircle: true,
          offset: {
            y: -2,
          },
          arrow: {
            vertical: 'top',
            horizontal: 'left',
          },
        },
        {
          selector: '.js-home-subnav .SubNav-item:nth-child(1)',
          text: 'Here you’ll find the most recent posts.',
          forceCircle: true,
          offset: {
            y: -6,
          },
          arrow: {
            vertical: 'top',
            horizontal: 'center',
          },
        },
        {
          selector: '.js-home-subnav .SubNav-item:nth-child(2)',
          text: "Here you'll find the community’s top posts.",
          forceCircle: true,
          offset: {
            y: -6,
          },
          arrow: {
            vertical: 'top',
            horizontal: 'center',
          },
        },
      ])
      .onVisit(1, [
        {
          selector: '.MainSearch-searchBar',
          text: `
            Enter keywords or names to search trending posts, and community members.
            `,
          arrow: {
            vertical: 'top',
            horizontal: 'right',
          },
        },
      ])
      .onVisit(2, [
        {
          selector: 'cdlc-mobile-post',
          gatherBox: el => {
            const postBox = el.getBoundingClientRect();
            postBox.x = postBox.right - 44;
            postBox.y += 10;
            postBox.height = 30;
            postBox.width = 30;

            return postBox;
          },
          text: `
              Click to save, block, or report members
              `,
          arrow: {
            vertical: 'center',
            horizontal: 'right',
          },
        },
      ])
      .run({ delay: 1e3 }, () => this.hints.tabBarReady.emit());
  }

  async createPost(e?) {
    this.preventDefault(e);
    if (!(await this.userVerification.isVerified())) {
      return;
    }

    if (this.user.unauthedUser) {
      return this.tools.loginBlock('You must be logged in to create a post.');
    }

    const modal = this.modalCtrl.create('CreatePostPage');
    modal.onDidDismiss(data => {
      if (!data) return;
      // const post = _.get(data, 'post') || {};
      // if (post) {
      //   const tab = _.findIndex(this.slideTabs, { id: 'latest' });
      //   if (tab !== this.tabsActiveTab) {
      //     this.changeActiveTabIndex(this.slideTabs[tab]);
      //   }
      //   if (this.feedLatest) {
      //     this.feedLatest.records.unshift(post);
      //   } else {
      //     setTimeout(() => {
      //       this.feedLatest.feed.on('records', () => {
      //         this.feedLatest.records.unshift(post);
      //       });
      //     });
      //   }
      // }
    });
    modal.present();
  }

  handleScrollStart = (event: any) => {
    // this.log('scrolling | handleScrollStart');
    if (!this.scrollHiding) return;

    const isScrollingDown = event.scrollTop > this.lastScrollPosition;
    const isAtTop = event.scrollTop <= 100;

    const newScrollingState = isAtTop ? false : isScrollingDown;

    if (newScrollingState !== this.isScrolling) {
      this.debounceScrollChange(newScrollingState);
      this.isScrolling = newScrollingState;
    }

    this.lastScrollPosition = event.scrollTop;
  };

  debounceScrollChange = this.debounce((isScrolling: boolean) => {
    this.tools.emit('isScrollingFeed', isScrolling);
    this.movePostFabUp = !isScrolling;
  }, 350);

  debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  refreshLiveChats(refresher) {
    this.tools.emit('refresh-live-chat', refresher);
  }

  scrollToTop(feed) {
    this.log('scrollToTop |' + feed);
    try {
      if (feed === 'top' || feed === 0) {
        this.contentTop.scrollToTop();
      } else if (feed === 'latest' || feed === 1) {
        this.contentLatest.scrollToTop();
      } else if (feed === 'friends' || feed === 2) {
        this.contentFriends.scrollToTop();
      } else if (feed === 'nearby' || feed === 3) {
        this.contentNearby.scrollToTop();
      } else if (feed === 'news' || feed === 4) {
        this.contentNews.scrollToTop();
      }
    } catch(e) {}
  }

  async changeActiveTabIndex(tab) {
    this.log('changeActiveTabIndex', tab.id, tab, this.slides._slides);
    // this.showFilters = false;

    if (!this.slides._slides) return console.warn('no slides found to navTo');
    
    const tabIndex = _.findIndex(this.slides._slides, slideNativeElement => {
      this.log('changeActiveTabIndex', slideNativeElement.id);
      return slideNativeElement.id === 's-' + tab.id;
    });
    this.log('changeActiveTabIndex', tab.id, tabIndex, tab);
    
    this.scrollToTop(tab.id);
    
    if (tab?.disabled) {
      this.toastCtrl
      .create({
        message:
        this.liveChatConfigs?.closedMessage ||
        'Live chat is currently unavailable. Please check back later.',
        duration: 1500,
        position: 'bottom',
      })
      .present();
      return;
    }
    
    let canContinue = true;
    if (tab?.injectionFn) {
      await tab.injectionFn().catch(e => {
        return (canContinue = false);
      });
    }
    
    if (!canContinue) return;
    
    this.log('tabIndex', tabIndex, this.tabsActiveTab);
    if (tabIndex === this.tabsActiveTab) {
      this.activatedSlides[tabIndex] = false;
      this.refreshing = tab.id;
      setTimeout(() => {
        this.activatedSlides[tabIndex] = true;
        this.refreshing = '';
      }, 800);
    } else {
      this.log('not setting refreshing');
    }
    
    this.tabsActiveTab = tabIndex;
    this.pageTitle = _.get(this.slideTabs[this.tabsActiveTab], 'label') || 'CDLLife';
    localStorage.setItem('cdlc--last-feed-id', tab.id);
    this.goToSlide(tabIndex);

    if (tab) {
      this.tools.logAnalyticsEvent('trackCustom', 'feeds-' + tab.id);
    }

    if (tab.id === 'top') {
      setTimeout(() => {
        this.tools.emit('refresh-announcements');
      });
    }
  }

  private goToSlide(slideIndex: number) {
    this.slides.lockSwipes(false);
    this.slides.slideTo(slideIndex);
    this.slides.lockSwipes(true);
    if (!this.activatedSlides[slideIndex]) {
      this.activatedSlides[slideIndex] = true;
    }
  }

  addFriends() {
    this.tools.loginBlock('Add new friends by signing in or signing up', {
      title: "No Friends? That's OK",
    });
  }

  preventDefault(e) {
    try {
      e.stopPropagation();
      e.preventDefault();
    } catch (e) {}
  }

  ionViewWillEnter() {}

  ngOnDestroy() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  resetSelected() {
    this.configs.resetTags();
    this.showPinnedPosts = true;
    // this.selectedTags.length = 0;
    // this.tags.map((tag) => {
    //   const el = document.getElementById(tag);
    //   const modalEl = document.getElementById(`modal-${tag}`);
    //   if (el && el.classList.contains('selected'))
    //     el.classList.remove('selected');
    //   if (modalEl && modalEl.classList.contains('selected'))
    //     modalEl.classList.remove('selected');
    // });
  }

  toggleTag(tag) {
    const id = _.get(tag, 'name');

    if (!id) return;

    const selected = _.get(tag, 'selected') || false;
    _.set(tag, 'selected', !selected);

    this.log('toggleTag', tag, this.tabsActiveTab);

    this.scrollToTop(this.tabsActiveTab);

    setTimeout(() => {
      this.configs.updateSelectedTags(tag);
    });
  }

  selectTags() {
    this.openTagsModal = true;
    this.tagSlideover.hide();
  }

  includes(tag) {
    return _.includes(this.selectedTags, tag);
  }

  /*
  handleTagMenuDisplay() {
    let topTagDisplay = document.getElementById('tagFeedMenu');

    if (!topTagDisplay) return;

    let rect = topTagDisplay.getBoundingClientRect();

    if (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
      this.tools.emit('tagFeedMenuInView');
      this.movePostFabUp = false;
    } else {
      this.tools.emit('tagFeedMenuOutOfView');
      this.movePostFabUp = true;
    }
  }
  */

  /*
  handleDrawerToggle(open = false) {
    if (open) {
      this.movePostFabUp = true;
    } else {
      this

    this.drawerOpen = open;
  }
  */
  showIntroPostComponent() {
    let accountCreated = _.get(this.user, 'info.dates.created');
    let totalAmountOfPosts = _.get(this.user, 'info.stats.events.post');
    const ageOfUserAccount = moment().diff(accountCreated, 'months');

    if (totalAmountOfPosts < 1 && ageOfUserAccount < 1) {
      this.showIntroPostEntryPoint = true;
    }
    let completedIntroPost = JSON.parse(
      localStorage.getItem('finished-intro-post')
    );
    setTimeout(() => {
      if (completedIntroPost != null) {
        const tab = _.findIndex(this.slideTabs, { id: 'latest' });
        this.changeActiveTabIndex(this.slideTabs[tab]);
        localStorage.removeItem('finished-intro-post');
      }
    }, 200);
  }

  handlePostFabLocation(event) {
    this.movePostFabUp = event;
  }

  refreshRoomPrompts() {
    this.tools.emit('refreshRoomPrompts');
  }

  handleRefresher(handler) {
    this.refresherEnabled = true;

    setTimeout(() => {
      if (handler === 'enable') {
        this.refresherEnabled = true;
      }
      if (handler === 'disable') {
        this.refresherEnabled = false;
      }
    });

    // regardless, don't let it lock for more than 2 seconds
    setTimeout(() => {
      this.refresherEnabled = true;
    }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home/home.ts